import api from './api'

const archiveService = {
  // Get all archives
  getArchives: (params) => api.get('/mrd/archive', { params }),

  // Get archive by ID
  getArchiveById: (id) => api.get(`/mrd/archive/${id}`),

  // Get archive by file ID
  getArchiveByFile: (fileId) => api.get(`/mrd/archive/file/${fileId}`),

  // Archive file
  archiveFile: (fileId, data) => api.post(`/mrd/archive/${fileId}`, data),

  // Retrieve from archive
  retrieveArchive: (archiveId, data) => api.post(`/mrd/archive/${archiveId}/retrieve`, data),

  // Bulk archive
  bulkArchive: (fileIds, data) => api.post('/mrd/archive/bulk-archive', {
    fileIds,
    ...data
  }),

  // Search archives
  searchArchives: (params) => api.get('/mrd/archive/search/global', { params }),

  // Get archives by location
  getArchivesByLocation: (location, params) => api.get(`/mrd/archive/location/${location}`, { params }),

  // Get archive statistics
  getArchiveStats: (params) => api.get('/mrd/archive/stats/summary', { params }),

  // Get archive dashboard
  getArchiveDashboard: () => api.get('/mrd/archive/dashboard/data'),

  // Get retention report
  getRetentionReport: (params) => api.get('/mrd/archive/retention-report', { params }),

  // Schedule destruction
  scheduleDestruction: (archiveId, data) => api.post(`/mrd/archive/${archiveId}/destroy`, data),

  // Destroy batch
  destroyBatch: (data) => api.post('/mrd/archive/destroy-batch', data),

  // Get destruction log
  getDestructionLog: (params) => api.get('/mrd/archive/destruction-log', { params }),

  // Update archive location
  updateArchiveLocation: (archiveId, locationData) => 
    api.post(`/mrd/archive/${archiveId}/update-location`, locationData),

  // Update archive condition
  updateArchiveCondition: (archiveId, data) => 
    api.patch(`/mrd/archive/${archiveId}/condition`, data),

  // Get archive audit trail
  getArchiveAuditTrail: (archiveId) => api.get(`/mrd/archive/audit/${archiveId}`)
}

export default archiveService